export const ru = {
    'freelancer-is-busy': 'занят',
    'freelancer-is-busy-is-owner': 'Я занят',
    'freelancer-is-cooperating': 'вы сотрудничаете',
    'freelancer-is-free': 'свободен',
    'freelancer-is-free-is-owner': 'Я свободен'
};
